import React, { useState } from "react";
import { Modal } from "react-bootstrap";

import { toast } from "react-toastify";
import CustomSelect from "../../../utils/CustomSelect";
import { Button, Form, Input, Label, StyledImgUpload, Textarea } from "../../../styles";
import { useSupplierContext } from "../../../context/supplier_context";
import Api from "../../../api/axios";
import MiniLoader from "../../../utils/MIniLoader";
import AddItemCategory from "./AddItemCategory";
import { useItemContext } from "../../../context/item_context";
import { useUserContext } from "../../../context/user_context";
import { convertPhoto } from "../../../utils/helpers";
import { placeholder } from "../../../assets";


const AddItem = () => {
  const [issending, setissending] = useState(false);

  const [formField, setformField] = useState({});

  const {
    showAddItem, CloseAddItem,
    openAddItemCategory,
    itemCategoryData, getItemCategoryData, itemCategoryLoading,
    getItemData, getServiceData, type,
  } = useItemContext();

  const { usertoken, btoken, stoken } = useUserContext();

  const { supplierLoading, allSuppliers, getSupplierData, } = useSupplierContext();


  function getFn() {
    getItemCategoryData();
    getSupplierData();
  }

  function handleChange(e) {
    if (e.target.name === 'photo') {
      setformField((inputs) => ({
        ...inputs,
        [e.target.name]: e.target.files[0],
      }));
    } else {
      setformField((inputs) => ({
        ...inputs,
        [e.target.name]: e.target.value,
      }));
    }
  }

  const category = itemCategoryData?.map(({ category, id }) => {
    return (
      { label: category, value: id }
    );
  });
  const supplier = allSuppliers?.map(({ name, id }) => {
    return (
      { label: name, value: id }
    );
  });
  // const type = itemType?.map(({ name, value }) => {
  //   return (
  //     { label: name, value: value }
  //   );
  // });

  function clear() {
    setformField({
      item: '',
      icid: '',
      details: '',
      sid: '',
      type: '',
      photo: '',
    });
  }

  function submitFn(e) {
    e.preventDefault();
    if (
      formField.item,
      formField.icid,
      formField.details,
      type
    ) {
      setissending(true);
      const data = {
        usertoken, btoken, stoken,
        item: formField.item,
        icid: formField.icid,
        details: formField.details,
        sid: formField.sid,
        type: type === 'item' ? 'product' : 'service',
        image: formField.photo,
      };

      Api.post(`/addItem`, data)
        .then((res) => {
          if (res.success === false) {
            toast.warn(res.message);
            setissending(false);
          } else {
            setissending(false);
            toast.success(res.message);
            clear();
            getItemData();
            getServiceData();
            CloseAddItem();
          }
        })
        .catch(() => {
          setissending(false);
        });
    } else {
      setissending(false);
      toast.warn("Empty Fields !!!");
    }
  }

  return (
    <>
      <Modal
        show={showAddItem}
        onHide={CloseAddItem}
        backdrop="static"
        keyboard={true}
        onEnter={() => getFn()}
        centered
        size="lg"
      >
        <Modal.Body>
          <Modal.Header closeButton>
            <h6 className="fw-bold pry-text text-capitalize">
              Create new {type}
            </h6>
          </Modal.Header>

          <div className="container">
            <Form onSubmit={(e) => submitFn(e)}>

              <Label> Image:</Label>
              <StyledImgUpload>
                <div className="d-flex flex-wrap justify-content-center align-items-center">
                  <img
                    src={formField.photo || placeholder}
                    alt='Item '
                    className="br-md"
                  />
                  <p className="ms-2 pry-text"> Click to upload</p>
                  <div className="file-upload">
                    <Input
                      type="file"
                      accept="image/*"
                      onChange={(e) => convertPhoto(e, setformField)}
                    />
                  </div>
                </div>

              </StyledImgUpload>

              <Label> Category: <span>*</span>
                <MiniLoader
                  load={itemCategoryLoading}
                  size={15}
                />
              </Label>
              <CustomSelect
                options={category}
                isSearchable={true}
                onChange={(e) => setformField((input) => ({ ...input, icid: e.value }))}
                placeholder='Select Category'
                required
              />
              <p
                className="pry-text text-decoration-underline pointer small"
                onClick={(e) => openAddItemCategory()}
              >
                Category not found? Add new
              </p>

              <Label className="text-capitalize"> {type} Name: <span>*</span></Label>
              <Input
                type="text"
                name="item"
                placeholder="e.g. Rice"
                onChange={handleChange}
                required
                value={formField.item}
              />

              {/* <Label>Type: <span>*</span> </Label>
              <CustomSelect
                options={type}
                isSearchable={true}
                onChange={(e) => setformField((input) => ({ ...input, type: e.value }))}
                required
                placeholder='Select Item Type'
              /> */}

              <Label>Supplier:
                <MiniLoader
                  load={supplierLoading}
                  size={15}
                />
              </Label>
              <CustomSelect
                options={supplier}
                isSearchable={true}
                onChange={(e) => setformField((input) => ({ ...input, sid: e.value }))}
                placeholder='Select Supplier'
              />

              <Label> Description: <span>*</span></Label>
              <Textarea
                type="text"
                name="details"
                placeholder="Enter details"
                onChange={handleChange}
                required
                value={formField.details}
              />

              <div className="col-md-10 mx-auto text-center mb-4">
                <Button
                  pry
                  type="submit"
                  disabled={issending}
                  className="btn m-0 w-100"  >
                  {issending ? 'loading...' : "Submit"}
                </Button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>

      {/* Add Item Modal */}
      <AddItemCategory
      />
      {/* Add Item Modal */}
    </>
  );
};

export default AddItem;
